export enum CrmSignalKeyEnum {
  VI = 'VI',
  INTENT = 'INTENT',
  ICP = 'ICP',
  JOB_CHANGE = 'JOB_CHANGE',
  NEWS = 'NEWS',
}


